import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import { IconProps } from '@models/icons';
import { pressActionEffect } from '@styles/mixin';
import { JSX } from 'react';

interface Props {
    icon: (props: IconProps) => JSX.Element;
    title: string;
    content?: string;
    onClick?: () => void;
}

function CsItem({
    icon: Icon, title, content, onClick,
}:Props) {
    return (
        <Container onClick={onClick}>
            <Row fullWidth justify='space-between'>
                <Row spacing={2}>
                    <Icon size={16} color={colors.textSecondary} />
                    <Text size='title' fontWeight='medium' color={colors.textPrimary}>{title}</Text>
                </Row>
                <ArrowLineRight size={16} color='var(--color-icon-unselected)'/>
            </Row>
            {content && (
                <Text color={colors.textSecondary} size='body-long' css={css`
                white-space: pre-wrap;
            `}>{content}</Text>
            )}
        </Container>
    );
}

const Container = styled.div`
    background-color: ${colors.gray1};
    padding: 16px;
    border-radius: var(--radius-xs);
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    ${pressActionEffect}
`;

export default CsItem;
